import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../../utl/models/Message";
import { ServiceState } from "../models/ServiceState";

const setMessage = (state: ServiceState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;